export const ROUTE_INDEX ="/";
export const ROUTE_PARTNERS ="/partners";
export const ROUTE_CONTACT_US ="/contact-us";
export const ROUTE_PRODUCTS ="/products";
export const ROUTE_PRODUCTS_QUADRO_SUITE ="/products/quadro";
export const ROUTE_PRODUCTS_QUADRO_PMS ="/products/quadro/pms";
export const ROUTE_PRODUCTS_QUADRO_FNB ="/products/quadro/fnb";
export const ROUTE_PRODUCTS_QUADRO_POP ="/products/quadro/pop";
export const ROUTE_PRODUCTS_QUADRO_ENTERTAINMENT  ="/products/quadro/entertainment";
